"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageableSerializer = void 0;
const pageable_1 = require("./pageable");
class PageableSerializer {
    serialize(response) {
        const data = response.data || [];
        return new pageable_1.Pageable({
            options: { limit: response.limit, skip: response.skip },
            data: data.map((item) => this.serializeOne(item)),
        });
    }
}
exports.PageableSerializer = PageableSerializer;
//# sourceMappingURL=pageable.serializer.js.map